export const apiCallParameters = {
    VAS_CONTACT_SUPPORT_LAMBDA: "VASContactSupportLambda",
    VAS_CONTACT_SUPPORT_DATA: "VASContactSupportData",
    CREATE_CONTACT_SUPPORT_CASE_DATA: "CreateContactSupportCase",
    SEARCH_CONTACT_SUPPORT_CASE_DATA: "SearchContactSupportCases",
}
